import { useEffect, useRef } from 'react';
export const fadeVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: 'easeInOut'
    }
  }
};
export const useTravelerButton = _ref => {
  let {
    travelerId,
    activeTraveler,
    selectedSeat,
    onChange,
    setTravelerButtonWithRemoveLink
  } = _ref;
  const isActive = travelerId === activeTraveler;
  const buttonRef = useRef(null);
  useEffect(() => {
    if (isActive) {
      var _buttonRef$current;
      (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    }
  }, [isActive]);
  const handleClick = e => {
    var _onChange;
    onChange === null || onChange === void 0 || (_onChange = onChange(travelerId)) === null || _onChange === void 0 || _onChange(e);
    setTravelerButtonWithRemoveLink(selectedSeat ? travelerId : undefined);
  };
  const handleFocus = () => setTravelerButtonWithRemoveLink(travelerId);
  return {
    buttonRef,
    handleClick,
    handleFocus,
    isActive
  };
};
//# sourceMappingURL=useTravelerButton.js.map